import types from './types';
const appActions = {
    // designed for auth reset
    resetStore: () => ({ type: types.RESET }),
    onPageChanged: () => ({ type: types.PAGE_CHANGED }),
};
export default appActions;
